import { createFileRoute } from "@tanstack/react-router";
import Analytics from "@/features-root-user/dashboard/analytics";
import { dashboardQueryOptions } from "@/features-root-user/service/dashboard";
import { queryClient } from "@/main";

export const Route = createFileRoute("/_root/root-user/dashboard/analytics")({
  component: Analytics,
  loader: async () => {
    queryClient.ensureQueryData(dashboardQueryOptions);
  },
});
